import { render, staticRenderFns } from "./UsuarioPerfilAssociacaoPage.vue?vue&type=template&id=475bd4a2"
import script from "./UsuarioPerfilAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./UsuarioPerfilAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports